export const ASYNC_TEAM_FETCH_STANDINGS_REQUEST = 'ASYNC_TEAM_FETCH_STANDINGS_REQUEST';
export const ASYNC_TEAM_FETCH_STANDINGS_SUCCESS = 'ASYNC_TEAM_FETCH_STANDINGS_SUCCESS';
export const ASYNC_TEAM_FETCH_STANDINGS_ERROR = 'ASYNC_TEAM_FETCH_STANDINGS_ERROR';


// WEBPACK FOOTER //
// ./src/screens/standingsScreen/state/types.js